<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.5"
      y="3.25"
      width="13"
      height="9.5"
      rx="1.5"
      :stroke="color"
      stroke-width="1.3"
    />
    <path
      d="M2.25 4.5 8 8.5l5.75-4"
      :stroke="color"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'V2IconsEnvelope'
})

defineProps({
  color: {
    type: String,
    default: 'currentColor'
  }
})
</script>
